import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-booking-activation-required-dialog',
    templateUrl: './booking-activation-required-dialog.component.html',
    styleUrls: ['./booking-activation-required-dialog.component.css'],
    standalone: false
})
export class BookingActivationRequiredDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<BookingActivationRequiredDialogComponent>,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.router.navigate(['/resume']);
    this.dialogRef.close();
  }

  onActivate(): void {
    this.router.navigate(['/subscription'], { queryParams: { activateBooking: 'true' } });
    this.dialogRef.close();
  }
}
